// extracted by mini-css-extract-plugin
export default {"priceDatesTitles":"datesPanel_priceDatesTitles__mRAfi","titlesItems":"datesPanel_titlesItems__EUKGr","dateItems":"datesPanel_dateItems__vk1qW"};